import React from "react";

import { Typography } from "@mui/material";
import DefaultCell from "root/entities/TableCells/Custom/DefaultCell";
import PercentDiffCell from "root/entities/TableCells/Custom/PercentDiff";
import YesOrNoCell from "root/entities/TableCells/Custom/YesOrNo";
import { postfixes } from "root/utils";
import globalColumns from "root/utils/columns/data";
import { socialNetworksData } from "root/utils/socialNetworks";
import {
  getBloggerSizeTitle,
  getSuccessLevelTitle,
  successLevelOptions,
} from "root/utils/socialNetworks/bloggers";
import BloggersTooltipLayout from "root/utils/socialNetworks/BloggersTooltipLayout";

import { yesNoSelectorOptions } from "./components/ByParameters/TypedFiltersLayout/YesOrNoSelector";

// --------------------------- RENDER METHODS

export const mappedArticleOptions = [
  { id: "any", title: "Все посты", serverValue: undefined },
  { id: "yes", title: "Посты только с подменным артикулом", serverValue: true },
  { id: "no", title: "Посты без подменного артикула", serverValue: false },
];

//
const tooltipPS =
  "В расчет данного показателя берутся последние известные данные, полученные при сборе публикаций.";
//
export const bloggersPostsColumnsTooltipPS = tooltipPS;
export const bloggersPostsColumns = [
  // --------------------------------------------------- BEHAVIORAL
  {
    dataIndex: "w_proceeds",
    tooltip: (
      <BloggersTooltipLayout PS={tooltipPS}>
        Расчетная выручка от интеграции за 3 дня после публикации.
      </BloggersTooltipLayout>
    ),
    default: true,
  },
  {
    dataIndex: "w_price",
    tooltip: (
      <BloggersTooltipLayout PS={tooltipPS}>
        Средний чек товара за 3 дня после публикации.
      </BloggersTooltipLayout>
    ),
    default: true,
  },
  {
    dataIndex: "blogger__subscriber_count",
    title: globalColumns["subscriber_count"].title,
    tooltip: globalColumns["subscriber_count"].tooltip,
    postfix: null,
    default: true,
    render: value => getBloggerSizeTitle(value),
  },
  {
    dataIndex: "view_count",
    tooltip: (
      <BloggersTooltipLayout PS={tooltipPS}>
        Общее количество просмотров публикации.
      </BloggersTooltipLayout>
    ),
    default: true,
    render: value => (
      <DefaultCell hideZero value={value} postfix={postfixes.pcs} fontWeight={400} />
    ),
  },
  {
    dataIndex: "reactions_count",
    tooltip: (
      <>
        <b>Количество реакций.</b>
        <br />
        Общее количество реакций на публикацию блогера - лайков, комментариев, сохранений и
        репостов.
      </>
    ),
    default: true,
    render: value => <DefaultCell value={value} postfix={postfixes.pcs} fontWeight={400} />,
  },
  {
    dataIndex: "er",
    default: true,
    render: value => (
      <DefaultCell
        value={value}
        postfix={postfixes.percent}
        empty="Не удалось рассчитать"
        round={2}
        fontWeight={400}
      />
    ),
  },
  {
    dataIndex: "err",
    default: true,
    render: value => (
      <DefaultCell
        value={value}
        postfix={postfixes.percent}
        empty="Не удалось рассчитать"
        round={2}
        fontWeight={400}
      />
    ),
  },
  {
    dataIndex: "success_level",
    default: true,
    render: value => getSuccessLevelTitle(value),
  },
  {
    dataIndex: "proceeds",
    title: `Выручка после публикации`,
    tooltip: (
      <>
        <b>Суммарная выручка за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
    render: value => <DefaultCell value={value} postfix={postfixes.pcs} fontWeight={400} />,
  },
  {
    dataIndex: "orders",
    title: "Заказов после публикации",
    tooltip: (
      <>
        <b>Суммарное количество заказов за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
    render: value => <DefaultCell value={value} postfix={postfixes.pcs} fontWeight={400} />,
  },
  {
    dataIndex: "lost_proceeds",
    title: "Упущ. выручка после публикации",
    tooltip: (
      <>
        <b>Суммарная упущенная выручка за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
    render: value => <DefaultCell value={value} postfix={postfixes.percent} fontWeight={400} />,
  },
  {
    dataIndex: "lost_orders",
    title: "Упущ. заказы после публикации",
    tooltip: (
      <>
        <b>Суммарные упущенные заказы за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
    render: value => <DefaultCell value={value} postfix={postfixes.pcs} fontWeight={400} />,
  },
  {
    dataIndex: "w_orders",
    tooltip: (
      <>
        <b>Расчетное кол-во заказов от интеграции за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
    render: value => <DefaultCell value={value} postfix={postfixes.pcs} fontWeight={400} />,
  },
  {
    dataIndex: "w_price_diff",
    tooltip: (
      <>
        <b>Изменение среднего чека от интеграции за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
    render: value => <DefaultCell value={value} postfix={postfixes.rub} fontWeight={400} />,
  },
  {
    dataIndex: "w_price_percent",
    tooltip: (
      <>
        <b>Изменение среднего чека от интеграции за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
    render: value => <DefaultCell value={value} postfix={postfixes.percent} fontWeight={400} />,
  },
  {
    dataIndex: "before_out_of_stock",
    title: "Out-of-stock до публикации",
    tooltip: (
      <>
        <b>Обнуление остатков в период 3-х дней до публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
    render: value => <YesOrNoCell {...{ value }} />,
  },
  {
    dataIndex: "after_out_of_stock",
    title: "Out-of-stock после публикации",
    tooltip: (
      <>
        <b>Обнуление остатков в период 3-х дней после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
    render: value => <YesOrNoCell {...{ value }} />,
  },
  {
    dataIndex: "proceeds_diff",
    title: "Прирост выручки артикула после публикации",
    tooltip: (
      <>
        <b>Прирост выручки за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
    render: value => <DefaultCell value={value} postfix={postfixes.rub} fontWeight={400} />,
  },
  {
    dataIndex: "proceeds_percent",
    title: "Прирост выручки артикула после публикации",
    tooltip: (
      <>
        <b>Прирост выручки за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
    render: value => <PercentDiffCell percent={value} />,
  },
  {
    dataIndex: "lost_proceeds_diff",
    title: "Прирост упущ. выручки после публикации",
    tooltip: (
      <>
        <b>Прирост упущенной выручки за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
    render: value => <DefaultCell value={value} postfix={postfixes.rub} fontWeight={400} />,
  },
  {
    dataIndex: "lost_proceeds_percent",
    title: "Прирост упущ. выручки после публикации",
    tooltip: (
      <>
        <b>Прирост упущенной выручки за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
    render: value => <DefaultCell value={value} postfix={postfixes.percent} fontWeight={400} />,
  },
  {
    dataIndex: "orders_diff",
    title: "Прирост заказов после публикации",
    tooltip: (
      <>
        <b>Прирост количества заказов за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
    render: value => <DefaultCell value={value} postfix={postfixes.pcs} fontWeight={400} />,
  },
  {
    dataIndex: "orders_percent",
    title: "Прирост заказов после публикации",
    tooltip: (
      <>
        <b>Прирост количества заказов за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
    render: value => <PercentDiffCell percent={value} />,
  },
  {
    dataIndex: "lost_orders_diff",
    title: "Прирост упущ. заказов после публикации",
    tooltip: (
      <>
        <b>Прирост упущенных заказов за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
    render: value => <DefaultCell value={value} postfix={postfixes.pcs} fontWeight={400} />,
  },
  {
    dataIndex: "lost_orders_percent",
    title: "Прирост упущ. заказов после публикации",
    tooltip: (
      <>
        <b>Прирост упущенных заказов за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
    render: value => <DefaultCell value={value} postfix={postfixes.percent} fontWeight={400} />,
  },
].map(item => {
  const { title, tooltip, postfix } = globalColumns[item.dataIndex] || {};
  return { title, postfix, tooltip, ...item, sortable: true };
});

//  -------------------------------------------------------------------------------------------------------
const bloggersPostsSelectionParamsForRedux = bloggersPostsColumns.reduce((acc, item) => {
  // ХЗ почему так, перенёс пока, потом разберусь
  acc[item.dataIndex + "__gte"] = "";
  acc[item.dataIndex + "__lte"] = "";
  acc[item.dataIndex + "__in"] = [];
  return acc;
}, {});
//  --------------------------------------------------------------------------------------------------------
const getDataForServerFromBloggersPostsParams = data => {
  const correctData = {};
  for (const key in data) {
    if (key.includes("lte") || key.includes("gte")) {
      // if (data[key]) correctData[key] = parseInt(data[key].slice(3).replace(/\s/g, ""));
      if (!isFinite(data[key])) continue;
      if (data[key]) correctData[key] = data[key];
    }
    // else if (key === "valueble")
    //   correctData[key] = externalTrafficOptions.find(item => item.id === data[key]).serverValue;
    else if (key === "before_out_of_stock" || key === "after_out_of_stock") {
      const found = yesNoSelectorOptions.find(item => item.id === data[key]);
      correctData[key] = found?.serverValue;
    } else if (key === "mapped_article__not_null") {
      const found = mappedArticleOptions.find(item => item.id === data[key]);
      correctData[key] = found?.serverValue;
    } else if (key.includes("__in")) {
      if (key === "success_level__in" && data[key].length === successLevelOptions.length) {
        console.log(data[key]);
        continue;
      }
      correctData[key] =
        Array.isArray(data[key]) && data[key].length ? data[key].join() : undefined;
    } else {
      switch (key) {
        case "account_name_hash":
          correctData[key + "__in"] = data[key].length
            ? data[key].map(item => item.id).join()
            : undefined;
          break;
        case "source":
          correctData[key + "__in"] = data[key].length ? data[key].join() : undefined;
          break;
        case "brand_id":
        case "product_id":
        case "subject":
          correctData[key + "__in"] = data[key].length
            ? data[key].map(item => item.id).join()
            : undefined;
          break;
      }
    }
  }
  // Отдельная логика для работы с блогерами, если не выбраны соцсети, но
  // выбраны блогеры, то надо фильтровать только по соцсетям выбранных блогеров
  if (correctData.account_name_hash__in && !correctData.source__in) {
    correctData.source__in = (data.account_name_hash || [])
      .reduce((acc, item) => {
        const sourceId = socialNetworksData.find(i => i.name === item.source)?.id;
        return sourceId && !acc.includes(sourceId) ? [...acc, sourceId] : acc;
      }, [])
      .join();
  }
  return correctData;
};

export { getDataForServerFromBloggersPostsParams, bloggersPostsSelectionParamsForRedux };
